.range-wrap {
  width: 100%;
  height: 3px;
  background-repeat: no-repeat;
  background-position: 0%;
  background-color: rgba(17, 23, 41, 1);
}
input[type='range'] {
  -webkit-appearance: none;
  width: 100%;
  transform: translateY(-1rem);
  &::-webkit-slider-runnable-track {
    height: 3px;
    box-shadow: none;
    background: rgb(var(--bs-info-rgb));
  }
  &:focus {
    outline: none;
  }
  &::-webkit-slider-thumb{
    -webkit-appearance: none;
    height: 1rem;
    width: 1rem;
    margin-top: -2px;
    background: #d8d8d8;
    border-radius: 50%;
  }
}

@-moz-document url-prefix() { 
  input[type='range']  {
    height: 3px;
    &::-moz-range-track{
      height: 3px;
      box-shadow: none;
      background: rgb(var(--bs-info-rgb));
    }
    &::-moz-range-thumb{
      height: 1rem;
      width: 1rem;
      margin-top: -2px;
      background: #d8d8d8;
      border-radius: 50%;
    }
  }
}